import { useDispatch, useSelector } from "react-redux";
import { getProducts } from "../../reducks/products/selectors";
import { getCategories } from "../../reducks/categories/selectors";
import { useEffect, useState } from "react";
import { fetchCategories } from "../../reducks/categories/operations";
import { fetchProducts } from "../../reducks/products/operations";
// カテゴリごとの色を定義
const categoryColors = [
  "#FFFFFF",
  "#FFD700",
  "#FF4500",
  "#00FF00",
  "#1E90FF",
  "#FF1493",
  "#00CED1",
  "#ADFF2F",
  "#FF69B4",
  "#87CEFA",
  "#DA70D6",
  "#F0E68C",
  "#FFA500",
  "#8A2BE2",
  "#7FFF00",
  "#40E0D0",
  "#FA8072",
  "#FF6347",
  "#C71585",
  "#BDB76B",
];
export const useGetInitialParams = () => {
  const dispatch = useDispatch();
  const products = useSelector(getProducts);
  const [sortedProducts, setSortedProducts] = useState(products);
  const categories = useSelector(getCategories);
  const [categoryId, setCategoryId] = useState("all");
  const [categoryList, setCategoryList] = useState([]);
  useEffect(() => {
    dispatch(fetchCategories());
  }, []);
  useEffect(() => {
    dispatch(fetchProducts("", "", ""));
  }, []);
  useEffect(() => {
    const newCategoryList = categories.map((category, index) => {
      return {
        id: category.cid,
        name: category.name,
        color: categoryColors[index % categoryColors.length], // カラーを順に割り当てる
      };
    });
    newCategoryList.unshift({ id: "all", name: "すべて", color: "#FFFFFF" });
    setCategoryList(newCategoryList);
  }, [categories]);
  useEffect(() => {
    setSortedProducts(products);
  }, [products]);
  return {
    categoryList,
    categoryId,
    setCategoryId,
    setSortedProducts,
    sortedProducts,
  };
};
